import { Base_Url, GeneratePdf_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

export const UploadImageWithNodeApi = async (params) => {
  const url = `${Base_Url}/Images/UploadDocument`;
  try {
    const formData = new FormData();
    formData.append("imageFile", params.imageFile); // Here, 'file' is the actual file object from input
    formData.append("moduleName", params.moduleName);
    formData.append("projectName", params.projectName);
    formData.append("userId", params.userId);
    // Debugging: Check FormData entries
    if (!(params.imageFile instanceof File)) {
      console.error("File object is invalid");
      return;
    }
    const response = await postApiWithAuthorization(url, formData);
    return response;
  } catch (error) {
    console.error("Error uploading Image :", error);
    throw error;
  }
};
